(function () {
	'use strict';

	angular.module('app.dashboard')
	.config(xMatrixConfig);

	function xMatrixConfig(dashboardProvider) {
		// register widget
		dashboardProvider
			.widget('xMatrix',
				{
					name: 'X-Matrix',
					description: 'View the lean projects x-matrix',
					thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/X-Matrix.png',
					categories: [],
					config: {},
					slideshowView: true,
					isActive: true,
					controller: 'xMatrix as xMatrixCtrl',
					templateUrl: 'lean-projects/x-matrix/x-matrix.html',
					reload: true,
					isDrillDown: false,
					nonRemovable: true
				}
			);
	}
})();
